import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { filterFieldsForForm } from 'drapcode-constant';
import ValidationRuleForm from './ValidationRuleForm';
import { addRule, updateRule, createSelectOptionsForField } from './validation-util';
import { removeQuery } from '../derived-query/query-util';
import { iconForField } from '../../../../common/custom/icon-library';
import { Mixpanel } from '../../../../common/utils/mixpanelUtil';
import { prepareValidationForValidationCreate } from '../../../data-connector/common/common_utils';

export default class ValidationForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  state = {
    rules: [],
  };

  handleValidationSubmit = (values) => {
    const { projectId, collection, version, actions } = this.props;
    const { rules } = this.state;
    const { customValidationName } = values;
    const finalObj = { customValidationName, validationRules: rules };
    actions.addRuleToCollection({
      projectId,
      collectionUuid: collection.uuid,
      version,
      data: finalObj,
    });
  };

  addValidationRule = () => {
    const rules = addRule(this.state.rules);
    this.setState({ rules });
  };

  removeRuleFromValidation = (id) => {
    const rules = removeQuery(this.state.rules, id);
    this.setState({ rules });
  };

  saveValidationRule = (id, ruleObj) => {
    const rules = updateRule(this.state.rules, id, ruleObj);
    this.setState({ rules });
  };

  clearForm = () => {
    this.setState({
      rules: [],
    });
  };

  createFormForRule = (setFieldValue, setFieldTouched) => {
    const { rules } = this.state;
    const { collection, collections, actions, projectId } = this.props;
    let collectionFields = createSelectOptionsForField(collection.fields);
    if (rules && rules.length > 0) {
      return rules.map((rule) => (
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode" key={rule.id}>
          <div className="card">
            <div className="card-header card-header-text" data-background-color="drapcode-violet">
              <h6 className="card-title pb-0 mb-0 text-capitalise">Rule #{rule.id}</h6>
            </div>
            <div className="card-content">
              <div className="row mx-auto" key={rule.id}>
                <ValidationRuleForm
                  rule={rule}
                  collections={collections}
                  actions={actions}
                  projectId={projectId}
                  collection={collection}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  fieldOptions={collectionFields}
                  fields={collection.fields}
                  removeRule={this.removeRuleFromValidation}
                  saveValidationRule={this.saveValidationRule}
                />
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      return '';
    }
  };

  render() {
    const { projectId, collection, collections } = this.props;
    const fields = filterFieldsForForm(collection.fields);
    if (!fields || fields.length === 0) {
      return <p>Please add some fields in you collection</p>;
    }
    return (
      <>
        <Formik
          enableReinitialize={true}
          initialValues={{ customValidationName: '' }}
          validationSchema={prepareValidationForValidationCreate()}
          onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {
            this.handleValidationSubmit(values);
            setSubmitting(false);
            this.clearForm();
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form className="form-horizontal">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Validation Name">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="customValidationName"
                      className="form-control form-control-sm"
                      placeholder="Name of Validation"
                    />
                    <ErrorMessage name="customValidationName">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              {this.createFormForRule(setFieldValue, setFieldTouched)}
              <div className="col-md-12 col-lg-12 text-right">
                <button
                  type="button"
                  className="btn btn-theme-green btn-sm"
                  onClick={() => {
                    this.addValidationRule();
                    Mixpanel.track('Clicked on- Add Rule in collection validation');
                  }}
                >
                  <i className="wb webconnect-plus"></i>&nbsp;Add Rule
                </button>
              </div>
              <div className="col-md-12 col-lg-12 text-right mt-4">
                <button type="reset" className="btn btn-default btn-md">
                  <i className="wb webconnect-eraser"></i>&nbsp;Reset
                </button>
                &nbsp;
                <button type="submit" className="btn btn-theme-submit btn-md">
                  <i className="wb webconnect-plus"></i>&nbsp;Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}
